import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import back_button from "../../assets/images/onboard/back_button.svg";
import BackgroundImg from "../../assets/USA_Images/login_images_visitor/loginbackgroundImage.png";
import HeaderI18n from "../../layout-components/HeaderI18n";
import CustomCarousel from "../../Pages/OnBoardV2/CustomCarousel";
import mysmgLogo from "../../../src/assets/USA_Images/user_profile/mysmgLogo.svg";
import visLogo from "../../assets/images/onboard/vis-logo.png";
import "./custom.css";
import { useEffect } from "react";
import { Box } from "@mui/material";
const darkModeStyles = {
  backgroundImage: `url(${BackgroundImg})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
};
const useStyles = makeStyles((theme) => ({
  container: {
    height: "90%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  footer: {
    bottom: "10px",
    marginLeft: "-180px",
    textAlign: "left",
    width: "100%",
    position: "absolute",
  },
  footer_USA: {
    bottom: "20px",
    textAlign: "center",
    width: "100%",
    position: "absolute",
  },
}));

function LoginLayoutV2({
  bgColor,
  color,
  width,
  height,
  fontFamily,
  lang,
  login_img,
  success,
  backbutton,
  login_img_vis,
  ...props
}) {
  const classes = useStyles();
  const { t } = useTranslation();
  const today = new Date();
  const year = today.getFullYear();

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const forgotPassWord = window.location.pathname.includes(
    "/vis/reset-password"
  );

  return (
    <Grid className="signin-container">
      <Grid component="main" maxWidth="full">
        <Grid container>
          <Grid item sm={6} xs={12} className="paper_left1">
            {props.src ? (
              <img
                src={props.src}
                height={"575px"}
                alt="logo"
                className="left_img"
              />
            ) : (
              <CustomCarousel />
            )}
          </Grid>
          <Grid
            item
            sm={6}
            xs={12}
            className="USA_SignIn-Right"
            style={darkModeStyles}
          >
            <Box
              style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
               backdropFilter: "blur(2px)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {backbutton && (
                  <Box
                    onClick={props.handleClick}
                    style={{
                      paddingLeft: "10px",
                    }}
                  >
                    <Tooltip title={props.title} style={{ cursor: "pointer" }}>
                      <img src={back_button} alt="logo" width={"42px"} />
                    </Tooltip>
                  </Box>
                )}
                {lang && (
                  <Box sx={{ marginLeft: "auto" }}>
                    <HeaderI18n />
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  overflow: "auto",
                  scrollbarWidth: "none",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                {props.children}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  paddingBottom: "10px",
                }}
              >
                <Typography
                  style={{ fontSize: "12px", color: "#fff", opacity: "0.8" }}
                  color="textSecondary"
                >
                  {t("COPY_RIGHT_1") + year + t("COPY_RIGHT_2")}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
LoginLayoutV2.propTypes = {
  bgColor: PropTypes.string,
  width: PropTypes.string,
};

LoginLayoutV2.defaultProps = {
  width: "150px",
};

export default LoginLayoutV2;
